import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useCountriesUIContext } from "../CountriesUIContext";

const prepareFilter = (queryParams, values) => {
  const { status, searchText } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by status
  filter.status = status !== "" ? +status : undefined;
 // Filter by all fields
  filter.name = searchText;
  if (searchText) {
    filter.email = searchText;
    filter.id = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CountriesFilter({ listLoading }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      setQueryParams: countriesUIContext.setQueryParams,
      queryParams: countriesUIContext.queryParams,
    };
  }, [countriesUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(countriesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, countriesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      countriesUIProps.setQueryParams(newQueryParams);
    }
  };

  if (((window.location.pathname.split("/")[2]) === "approved") || (window.location.pathname.split("/")[2]) === "rejected" || (window.location.pathname.split("/")[2]) === "pending") {
    return (
      <>
        <Formik
          initialValues={{
            approval_status: "",
            searchText: "",
          }}
          onSubmit={(values) => {
            applyFilter(values);
          }}
        >
          {({
            values,
            handleSubmit,
            handleBlur,
            handleChange,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-3">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search"
                    onBlur={handleBlur}
                    value={values.searchText}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Search</b> in all fields
                  </small>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  }
  else {
    return (
      <>
        <Formik
          initialValues={{
            status: "", // values => All=""/Selling=0/Sold=1
            condition: "", // values => All=""/New=0/Used=1
            searchText: "",
          }}
          onSubmit={(values) => {
            applyFilter(values);
          }}
        >
          {({
            values,
            handleSubmit,
            handleBlur,
            handleChange,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit} className="form form-label-right">
              <div className="form-group row">

                
                <div className="col-lg-2">
                  <input
                    type="text"
                    className="form-control"
                    name="searchText"
                    placeholder="Search"
                    onBlur={handleBlur}
                    value={values.searchText}
                    onChange={(e) => {
                      setFieldValue("searchText", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Search</b> in all fields
                  </small>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  }
}
